import { css } from "@emotion/react";

export const styPlace = css`
  padding: 20px;
  background-color: #ebe6d6;
  min-height: 150px;
  text-align: center;
`;

export const styPlaceCard = css`
  min-height: 150px;
  background-color: #f9f9f9;
  border-radius: 4px;
  margin: 24px 0;
`;

export const styPlaceCardTitle = css`
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  margin: 0;
  padding: 24px 0;
  background-color: #6b6445;
  text-transform: uppercase;
  color: #f9f9f9;
`;

export const styPlaceCardContent = css`
  p {
    margin: 8px 0;
  }
`;

export const styPlaceTitle = css`
  text-transform: uppercase;
  font-weight: 700;
`;

export const styPlaceButton = css`
  border-radius: 4px;
  background-color: #f9f9f9;
  border: 1px solid #6b6445;
  color: #6b6445;
  margin-top: 16px;
  width: 200px;
  padding: 8px;
`;
